var map = {
	"./findoctor/single-page/home-4": [
		"95f4",
		"chunk-9497ea90",
		"chunk-3fcc089f"
	],
	"./wedding/single-page/home-4": [
		"5227",
		"chunk-9497ea90",
		"chunk-7e603d82"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ea4b";
module.exports = webpackAsyncContext;